'use client';

import { useCallback, useMemo, useState } from 'react';
import { useConfig } from 'apps/cdp-web-demo/app/(main)/ConfigContext';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { LogoMark } from '@cbhq/cds-web/icons';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { HStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography';

import { ShareModal } from './(main)/components/ShareModal/ShareModal';
import { serializeConfigToQueryParams } from './(main)/utils/queryParams';
import styles from './SiteHeader.module.css';

function SiteHeader() {
  const font = useMemo(
    () => ({
      base: 'headline' as const,
      desktop: 'title3' as const,
    }),
    [],
  );
  const buttonDisplay = useMemo(
    () => ({
      base: 'none' as const,
      tablet: 'flex' as const,
      desktop: 'flex' as const,
    }),
    [],
  );
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const { state, isHydrated } = useConfig();
  const handleShareConfig = useCallback(() => {
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      url.search = ''; // Clear existing params
      const params = serializeConfigToQueryParams(state);
      url.search = params.toString();
      setShareUrl(url.toString());
      setIsShareModalOpen(true);
    }
  }, [state]);

  const handleCloseShareModal = useCallback(() => {
    setIsShareModalOpen(false);
  }, []);
  return (
    <>
      <header>
        <HStack
          as="header"
          gap={2}
          alignItems="center"
          justifyContent="flex-start"
          flexGrow={1}
          paddingY={2}
          className={styles.header}
        >
          <div className={styles['logo-container']}>
            <LogoMark size={32} />
          </div>
          <Text as="h1" font={font}>
            User Wallets Demo
          </Text>

          <div className={styles['btn-wrapper']}>
            {isHydrated && (
              <Button
                onClick={handleShareConfig}
                variant="primary"
                transparent
                className={styles['share-button']}
                compact
              >
                <Icon
                  name="share"
                  aria-hidden="true"
                  role="img"
                  size="s"
                  className={styles['share-button-icon']}
                />
                <span className={styles['share-button-text']}>Share preview</span>
              </Button>
            )}
            <Button
              as="a"
              compact
              endIcon="forwardArrow"
              href="https://docs.cdp.coinbase.com/wallets/quickstart/user-auth"
              paddingX={2}
              target="_blank"
              variant="primary"
              display={buttonDisplay}
              className={styles['start-button']}
            >
              Start building
            </Button>
          </div>
        </HStack>
      </header>
      <ShareModal isOpen={isShareModalOpen} shareUrl={shareUrl} onClose={handleCloseShareModal} />
    </>
  );
}

export default SiteHeader;
